import { render, staticRenderFns } from "./VueContainerConfig.vue?vue&type=template&id=18ec1452&scoped=true"
import script from "./VueContainerConfig.vue?vue&type=script&lang=js"
export * from "./VueContainerConfig.vue?vue&type=script&lang=js"
import style0 from "./VueContainerConfig.vue?vue&type=style&index=0&id=18ec1452&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ec1452",
  null
  
)

export default component.exports